import { render, staticRenderFns } from "./ClosureRequests.html?vue&type=template&id=70bea9c0&scoped=true&external"
import script from "./ClosureRequests.vue?vue&type=script&lang=js"
export * from "./ClosureRequests.vue?vue&type=script&lang=js"
import style0 from "./ClosureRequests.scss?vue&type=style&index=0&id=70bea9c0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bea9c0",
  null
  
)

export default component.exports